import { ORM } from './CouchORM2';
import parseFields from '../Utilities/parseFields';
import { db } from '../Database.svelte';

export default class FrameworkReference extends ORM {
    static modelName = "FrameworkReference";

    static parseReferenceFields(fields) {
        let formFields = [
            {
                name: "name",
                label: "Reference Number",
                type: "text",
                required: true
            }
        ]

        let sortFields = [
            {
                field: "name",
                label: "Reference Number",
                dataAttr: "reference_number",
                type: "text",
                required: true
            }
        ]

        let parsed_fields = parseFields(fields, false);

        return {
            formFields: [...formFields, ...parsed_fields.formFields],
            sortFields: [...sortFields, ...parsed_fields.sortFields]
        }
    }

    static async getFields(framework_id) {
        let results = await db.allDocs({
            startkey: `${framework_id}:fields:`,
            endkey: `${framework_id}:fields:~`,
            include_docs: true
        });

        return results.rows.map(r => r.doc);
    }
}